import React, { useCallback } from "react";
import { useDispatch } from "react-redux";

import { Skeleton } from "components";
import { AddressCoordinatesConstants } from "globalConstants";
import { uiActions } from "store";

import DisableLocationIcon from "static/images/disableLocation.png";
import LocationIcon from "static/images/location.png";
import styles from "../../merchantInfo.module.scss";

type AddressFieldRowProps = {
	label: string;
	data: any;
	value: string;
	isLoading: boolean;
	isDisabled?: boolean;
};

export const AddressFieldRow = ({
	label,
	data,
	value,
	isLoading,
	isDisabled,
}: AddressFieldRowProps) => {
	const dispatch = useDispatch();
	const showGeoLocationMap = useCallback(
		(locationTitle, currentAddress, addressLocation) => {
			let initialLocation: any = null;
			if (addressLocation?.latitude && addressLocation?.longitude) {
				initialLocation = {
					lat: addressLocation.latitude,
					lng: addressLocation.longitude,
				};
			} else {
				initialLocation = { lat: 0, lng: 0 };
			}

			dispatch(
				uiActions.showModal("GEO_LOCATION", {
					title: locationTitle,
					initialLocation,
					currentAddress,
				}),
			);
		},
		[dispatch],
	);
	const LocationWithLoader = useCallback(
		({ addressLocation, address, title, isDisabled }) => {
			const isManualAddress =
				AddressCoordinatesConstants.ManualAddress.lat ===
					addressLocation?.latitude ||
				AddressCoordinatesConstants.ManualAddress.lng ===
					addressLocation?.longitude;

			if (isLoading) {
				return (
					<Skeleton
						variant="text"
						marginBottom="16px"
						height="26px"
						width="20px"
					/>
				);
			} else {
				return (
					<>
						{isDisabled && !isManualAddress ? (
							<img
								src={LocationIcon}
								alt=""
								className={styles.locationIcon}
								onClick={() =>
									showGeoLocationMap?.(
										title,
										address,
										addressLocation,
									)
								}
							/>
						) : (
							<img
								src={DisableLocationIcon}
								alt=""
								className={styles.locationIcon}
							/>
						)}
					</>
				);
			}
		},
		[isLoading, showGeoLocationMap],
	);
	const FieldWithLoader = useCallback(
		({ text }) => {
			if (isLoading) {
				return (
					<Skeleton
						variant="text"
						marginRight={"15px"}
						marginBottom="16px"
						height="24px"
						width="90%"
					/>
				);
			} else {
				return <div className={styles.content}>{text}</div>;
			}
		},
		[isLoading],
	);
	return (
		<div className={styles.merchantFormDesc}>
			<label className={styles.merchantLabel}>{label}</label>
			<div className={styles.formContent}>
				<FieldWithLoader text={value} />
				<LocationWithLoader
					title={label}
					address={data?.address_line1}
					addressLocation={data}
					isDisabled={isDisabled}
				/>
			</div>
		</div>
	);
};
